import React, { useEffect, useRef, useState } from "react";
import Typography from "@mui/material/Typography";
import Breadcrumbs from "@mui/material/Breadcrumbs";
import Box from "@mui/material/Box";
import { GridColDef, GridPinnedColumnFields } from "@mui/x-data-grid";
import Paper from "@mui/material/Paper";
import {
    Button,
    IconButton,
    Popper,
    TextField,
    Badge,
    MenuItem,
    Menu,
    Stack,
    Tooltip,
    Avatar,
    Tabs,
    Tab
} from "@mui/material";
import CancelIcon from "@mui/icons-material/Cancel";
import Autocomplete from "@mui/material/Autocomplete";
import Grid from "@mui/material/Grid2";
import Chip from "@mui/material/Chip";
import FilterAltOutlinedIcon from "@mui/icons-material/FilterAltOutlined";
import { ThreeDot } from "react-loading-indicators";
import emptyImage from "../../assets/images/image.png";
import CircleIcon from "@mui/icons-material/Circle";

import { DataGridPro } from "@mui/x-data-grid-pro";
import MoreVertIcon from "@mui/icons-material/MoreVert";
import InfoOutlinedIcon from "@mui/icons-material/InfoOutlined";

import {
    getCompanyRfqMetaFilterData,
    getCURFQAssignedToMe,
    getCustomerRfqData,
    getCustomerRfqDataV1,
    getFrfqData
} from "../Services/OrgRepo";
import { CertificationDrawer } from "./CertificationDrawer";
import { Link, useNavigate } from "react-router-dom";
import {
    accountManager,
    generatProfilePicUrl,
    getLoggedInName,
    getLoggedInUserID,
    sourcingManager,
    sourcingManagerHead,
    isSourcingManagerHead,
    isManagement,
    Management,
    getLoggedInEmail,
    generateCompanyLogo,
    getLoggedInUserDepartment,
    productionManagerHead,
    NPDManager,
    NPDManagerHead,
    accountManagerHead,
    formatCurrencyValue,
    productionManager
} from "../../Utils/Constant";
import CurrencyRupeeIcon from "@mui/icons-material/CurrencyRupee";
import AttachMoneyIcon from "@mui/icons-material/AttachMoney";
import EuroIcon from "@mui/icons-material/Euro";
import oligasIcn from "../../assets/icons/oligas.png";
import evAutoIcn from "../../assets/icons/automotive.png";
import power from "../../assets/icons/power.png";
import industry from "../../assets/icons/industry.png";
import aerospace from "../../assets/icons/aerospace.png";
import { getCURFQAssignedToMeFilterMetaFieldsApi } from "../Services/FeasibleRFQ";
import { PriorityHigh } from "@mui/icons-material";
import { getAutoPopulateCoRFQDetailsForMMRFQApi } from "../Services/MMRfqForm";
import { useDispatch } from "react-redux";
import { setMmRfqFormData } from "../../Redux/MMRfq/actions";
import excliImage from "../../assets/icons/excli.png";
import TrendingUpIcon from "@mui/icons-material/TrendingUp";
import ErrorOutlineOutlinedIcon from "@mui/icons-material/ErrorOutlineOutlined";
import defaultlogo from "../../assets/icons/noimg.png";
import dayjs from "dayjs";

export const CURFQAssignedToMe = () => {
    const [searchTerm, setSearchTerm] = useState("");
    const [rows, setRows] = useState<string[]>([]);
    const [filteredRows, setFilteredRows] = useState(rows);
    const [selectedRows, setSelectedRows] = useState<string[]>([]);
    const [anchorEl, setAnchorEl] = useState(null);
    const [selectedStatus, setSelectedStatus] = useState([]);
    const [selectedKeyAccountManager, setSelectedKeyAccountManager] = useState(
        []
    );
    const [selectedSourcingManager, setSelectedSourcingManager] = useState([]);
    const [selectedCompany, setSelectedCompany] = useState([]);

    /* Set the tab value state based on logged in user - start */
    const Department = ["Sourcing", "Production", "NPD"];
    let assignedDeptTab = null;
    // Setting the dept tab value based on logged in user if NPD or Production
    if (
        getLoggedInUserDepartment() === Department[2] ||
        getLoggedInUserDepartment() === Department[1]
    ) {
        assignedDeptTab = getLoggedInUserDepartment();
    } else {
        // Default the dept tab is Sourcing
        assignedDeptTab = Department[0];
    }
    const [tabValue, setTabValue] = React.useState(assignedDeptTab);
    /* Set the tab value state based on logged in user - end */

    const [filteredSelectedStatus, setFilteredSelectedStatus] = useState([]);
    const [
        filteredSelectedKeyAccountManager,
        setFilteredSelectedKeyAccountManager
    ] = useState([]);
    const [
        filteredSelectedSourcingManager,
        setFilteredSelectedSourcingManager
    ] = useState([]);
    const [filteredSelectedCompany, setFilteredSelectedCompany] = useState([]);

    const [isLoading, setIsLoading] = useState<boolean>(false);
    const [isFilterLoading, setIsFilterLoading] = useState<boolean>(false);
    const searchInputRef = useRef<HTMLInputElement>(null);
    const [selectedRow, setSelectedRow] = useState(null);
    const [openDrawer, setOpenDrawer] = useState(false);
    const [filterOptions, setFilterOptions] = useState<{
        [key: string]: { title: string; value: string }[];
    }>({});
    const [isApplyFilter, setIsApplyFilter] = useState<Boolean>(false);
    const [isButtonDisable, setIsButtonDisable] = useState<boolean>(false);
    const [removeFilter, setRemoveFilter] = useState<boolean>(false);
    const popperRef = useRef<HTMLDivElement>(null);
    const [paginationModel, setPaginationModel] = React.useState({
        page: 0,
        pageSize: 10 // Default page size
    });
    const navigate = useNavigate();

    const [pinnedColumns, setPinnedColumns] =
        React.useState<GridPinnedColumnFields>({
            right: ["assigneeName", "action"],
            left: ["curfq_no", "curfq_name"]
        });
    const handlePinnedColumnsChange = React.useCallback(
        (updatedPinnedColumns: GridPinnedColumnFields) => {
            setPinnedColumns(updatedPinnedColumns);
        },
        []
    );
    const dispath = useDispatch();

    const handleOpenDrawer = async (row: any) => {
        setSelectedRow(row);
        setOpenDrawer(true);
    };

    const handleCloseDrawer = () => {
        setOpenDrawer(false);
    };

    const fetchCURFQAssignedToMe = async (payload) => {
        setIsLoading(true);
        try {
            const paylod = {
                userEmail: getLoggedInEmail(),
                status: "Assigned RFQs",
                department: payload?.department
            };
            const response = await getCustomerRfqDataV1(paylod);
            if (response?.status) {
                setRows(response?.data);
                setFilteredRows(response?.data);
            } else {
                setRows([]);
                setFilteredRows([]);
            }
        } catch (error) {
            console.error(error);
            setRows([]);
            setFilteredRows([]);
        } finally {
            setIsLoading(false);
        }
    };

    const [isInitialRender, setIsInitialRender] = useState(true);

    useEffect(() => {
        // if (isInitialRender) {
        //   setIsInitialRender(false); // Mark as rendered
        //   return; // Skip first execution
        // }
        const fetchdataInUseEffect = async () => {
            fetchCURFQAssignedToMe({ department: tabValue });
            setAnchorEl(null);
            setSelectedKeyAccountManager([]);
            setSelectedStatus([]);
            setSelectedCompany([]);
        };
        fetchdataInUseEffect();

        // Fetch filters if empty
        if (!filterOptions || Object.keys(filterOptions).length === 0) {
            fetchFilterData();
        }
    }, [tabValue]);

    const handleClearAll = () => {
        setSelectedKeyAccountManager([]);
        setSelectedStatus([]);
        setSelectedSourcingManager([]);
        setSelectedCompany([]);
    };

    const handleClearAllChip = () => {
        setSelectedKeyAccountManager([]);
        setSelectedStatus([]);
        setSelectedSourcingManager([]);
        setSelectedCompany([]);

        setFilteredSelectedKeyAccountManager([]);
        setFilteredSelectedStatus([]);
        setFilteredSelectedSourcingManager([]);
        setFilteredSelectedCompany([]);

        setFilteredRows(rows);
        setIsApplyFilter(false);
    };
    const handleClose = () => {
        setSelectedKeyAccountManager(filteredSelectedKeyAccountManager);
        setSelectedStatus(filteredSelectedStatus);
        setSelectedSourcingManager(filteredSelectedSourcingManager);
        setSelectedCompany(filteredSelectedCompany);

        setAnchorEl(null);
        // setFilteredRows(rows);
        // setIsApplyFilter(false);
    };

    const handleClick = (event: React.MouseEvent<HTMLButtonElement>) => {
        if (
            Object.keys(filterOptions)?.length === 0 ||
            filterOptions?.companyOptions
        ) {
            fetchFilterData();
        }
        setAnchorEl(event.currentTarget);
    };

    // Handle search input change
    const handleSearch = (event: React.ChangeEvent<HTMLInputElement>) => {
        const search = event?.target?.value;
        setSearchTerm(search);

        if (search?.length >= 3) {
            const filtered = rows?.filter((row) =>
                ["curfq_no", "curfq_name"].some(
                    (key) =>
                        typeof row[key] === "string" &&
                        row[key].toLowerCase().includes(search.toLowerCase())
                )
            );
            setFilteredRows(filtered);
        } else {
            setFilteredRows(rows);
        }
    };

    /** Assigned tab changes  */
    const handleChange = (event: React.SyntheticEvent, newValue: string) => {
        setTabValue(newValue);
        setAnchorEl(null);
        handleClearAll();
        handleClearAllChip();
    };

    const getFromValue = () => {
        if (sourcingManager() || sourcingManagerHead()) {
            return "CURFQAssignedToMe";
        }
        return "CURFQAssignedToMe";
    };
    useEffect(() => {
        if (searchInputRef.current) {
            searchInputRef.current.focus();
        }
    }, [searchTerm]);

    const CertTypeCell = ({
        value,
        isIndustryType,
        onChipClick
    }: {
        value?: string | string[]; // can be string or string array
        isIndustryType?: boolean;
        onChipClick?: (type: string) => void;
    }) => {
        const [expanded, setExpanded] = useState(false);
        const types = Array.isArray(value) ? value : value?.split(", ") || [];

        const displayedTypes = expanded ? types : types.slice(0, 2);
        const remainingCount = types?.length - 2;

        const handleChipClick = (type: string) => {
            if (!expanded) setExpanded(true); // expand on first click
            onChipClick?.(type); // trigger drawer or any external action
        };

        return (
            <Box
                sx={{
                    gap: 0,
                    alignItems: "center",
                    height: "100%",
                    flexWrap: "wrap",
                    padding: "5px 0 5px",
                    display: "flex"
                }}
            >
                {displayedTypes?.map((type, idx) =>
                    type ? (
                        <Chip
                            key={idx}
                            size="small"
                            label={type}
                            sx={{ margin: "5px 0px 0px 5px" }}
                            onClick={() => handleChipClick(type)}
                        />
                    ) : (
                        "-"
                    )
                )}
                {!expanded && remainingCount > 0 && (
                    <Chip
                        label={`+${remainingCount}`}
                        sx={{ cursor: "pointer", margin: "5px 0px 0px 5px" }}
                        onClick={(e) => {
                            e.stopPropagation();
                            e.preventDefault();
                            setExpanded(true);
                        }}
                        size="small"
                    />
                )}
                {expanded && (
                    <IconButton
                        size="small"
                        onClick={(e) => {
                            e.stopPropagation();
                            e.preventDefault();
                            setExpanded(false);
                        }}
                        sx={{ margin: "5px 0px 0px 5px" }}
                    >
                        <CancelIcon fontSize="small" />
                    </IconButton>
                )}
            </Box>
        );
    };

    const PartTypeCell = ({
        value
    }: {
        value?: { part_id: string; part_name: string }[];
    }) => {
        const [expanded, setExpanded] = useState(false);
        const types = value || [];

        const displayedTypes = expanded ? types : types.slice(0, 2);
        const remainingCount = types?.length - 2;

        return (
            <Box
                sx={{
                    display: "flex",
                    flexWrap: "wrap",
                    gap: 0,
                    alignItems: "center",
                    height: "100%",
                    padding: "5px 0 5px"
                }}
            >
                {displayedTypes.map((part, idx) => (
                    <Chip
                        key={idx}
                        size="small"
                        label={part.part_name || "-"}
                        sx={{ margin: "5px 0px 0px 5px" }}
                    />
                ))}

                {!expanded && remainingCount > 0 && (
                    <Chip
                        size="small"
                        label={`+${remainingCount}`}
                        sx={{ cursor: "pointer", margin: "5px 0px 0px 5px" }}
                        onClick={() => setExpanded(true)}
                    />
                )}
                {expanded && (
                    <IconButton
                        size="small"
                        onClick={() => setExpanded(false)}
                        sx={{ margin: "5px 0px 0px 5px" }}
                    >
                        <CancelIcon fontSize="small" />
                    </IconButton>
                )}
            </Box>
        );
    };

    const AssMmrfqID = ({
        value,
        onChipClickA
    }: {
        value?: string[];
        onChipClickA?: (type: string) => void;
    }) => {
        const [expanded, setExpanded] = useState(false);
        const ids = value || [];

        const displayedIds = expanded ? ids : ids.slice(0, 2);
        const remainingCount = ids?.length - 2;

        const handleChipClickA = (id: string) => {
            // if (!expanded) setExpanded(true); // expand on first click
            if (id) {
                onChipClickA?.(id);
            }
        };

        return (
            <Box
                sx={{
                    display: "flex",
                    flexWrap: "wrap",
                    alignItems: "center",
                    height: "100%",
                    padding: "5px 0 5px",
                    gap: 0
                }}
            >
                {ids?.length === 0 ? (
                    <>
                        <Chip
                            size="small"
                            label="Yet to create"
                            sx={{ margin: "5px 0px 0px 5px", cursor: "text" }}
                        />
                        <div style={{ alignItems: "center", display: "flex" }}>
                            <ErrorOutlineOutlinedIcon
                                sx={{ fontSize: "15px" }}
                                color="error"
                            />
                            <Typography
                                variant="caption"
                                color="error"
                                ml={0.5}
                            >
                                Requires Action
                            </Typography>
                        </div>
                    </>
                ) : (
                    <>
                        {displayedIds?.map((id, idx) => (
                            <Chip
                                key={idx}
                                size="small"
                                label={id || "-"}
                                onClick={() => id && handleChipClickA(id)}
                                sx={{ margin: "5px 0px 0px 5px" }}
                            />
                        ))}
                    </>
                )}
                {!expanded && remainingCount > 0 && (
                    <Chip
                        size="small"
                        label={`+${remainingCount}`}
                        sx={{ cursor: "pointer", margin: "5px 0px 0px 5px" }}
                        onClick={(e) => {
                            e.preventDefault();
                            e.stopPropagation();
                            setExpanded(true);
                        }}
                    />
                )}
                {expanded && (
                    <IconButton
                        size="small"
                        onClick={(e) => {
                            e.preventDefault();
                            e.stopPropagation();
                            setExpanded(false);
                        }}
                        sx={{ margin: "5px 0px 0px 5px" }}
                    >
                        <CancelIcon fontSize="small" />
                    </IconButton>
                )}
            </Box>
        );
    };

    const getCurrencyIcon = (currency) => {
        switch (currency) {
            case "INR":
                return <CurrencyRupeeIcon sx={{ fontSize: "0.875rem" }} />;
            case "USD":
                return <AttachMoneyIcon sx={{ fontSize: "0.875rem" }} />;
            case "EUR":
                return <EuroIcon sx={{ fontSize: "0.875rem" }} />;
            default:
                return null;
        }
    };

    function parseCustomDate(dateStr: string) {
        return dayjs(dateStr, "DD-MMM-YYYY HH:mm:ss").toDate();
    }

    const isHighValueRfq = (row) => {
        const { preferred_currency, total_order_value } = row;

        return (
            (preferred_currency === "INR" && total_order_value >= 5000000) ||
            (preferred_currency === "EUR" && total_order_value >= 50000) ||
            (preferred_currency === "USD" && total_order_value >= 50000)
        );
    };

    const columns: GridColDef[] = [
        {
            field: "curfq_no",
            headerName: "CORFQ ID",
            width: 120,
            disableColumnMenu: true,

            renderCell: (params) => {
                const payload = {
                    rfqData: {
                        ID: params.row.curfq_id,
                        rfqID: params.row.curfq_no,
                        notificationID: params.row.notificationID,
                        isNew: params.row.isNew
                    },
                    from: "CURFQAssignedToMe"
                };
                return (
                    <Link
                        to="/layout/CURFQDetails"
                        target="_blank"
                        state={{ payload }}
                        onClick={() => {
                            localStorage.setItem(
                                "CURFQDetails",
                                JSON.stringify(payload)
                            );
                        }}
                        style={{
                            textDecoration: "none"
                        }}
                    >
                        {params.row.curfq_no?.replace("CURFQ", "CORFQ")}
                    </Link>
                );
            }
        },
        {
            field: "curfq_name",
            headerName: "CORFQ Name",
            width: 200,
            disableColumnMenu: true,
            cellClassName: (params) => {
                return isHighValueRfq(params?.row) ? "rfq-high-value-cell" : "";
            },
            renderCell: (params) => {
                const highValue = isHighValueRfq(params?.row);
                const payload = {
                    rfqData: {
                        ID: params.row.curfq_id,
                        rfqID: params.row.curfq_no,
                        notificationID: params.row.notificationID,
                        isNew: params.row.isNew
                    },

                    from: "CURFQAssignedToMe"
                };
                return (
                    <>
                        {highValue && (
                            <>
                                <div className="highlightChip">
                                    High value{" "}
                                    <TrendingUpIcon sx={{ fontSize: "1rem" }} />
                                </div>
                            </>
                        )}
                        <Link
                            to="/layout/CURFQDetails"
                            target="_blank"
                            state={{ payload }}
                            onClick={() => {
                                localStorage.setItem(
                                    "CURFQDetails",
                                    JSON.stringify(payload)
                                );
                            }}
                            style={{
                                textDecoration: "none",
                                display: "flex",
                                justifyContent: "space-between",
                                width: "100%",
                                alignItems: "center"
                            }}
                        >
                            <span>{params?.value}</span>
                            {!accountManagerHead() && params?.row?.isNew && (
                                <CircleIcon
                                    sx={{ fontSize: "12px", color: " #1976d2" }}
                                />
                            )}
                        </Link>
                    </>
                );
            }
        },

        {
            field: "associated_mmrfq_id",
            headerName: "Associated MMRFQ ID",
            width: 150,
            disableColumnMenu: true,
            renderCell: (params) => {
                const status = params?.row?.status;
                const payload = {
                    rfqData: {
                        ID: params?.row?.curfq_id,
                        rfqID: params?.row?.curfq_no,
                        notificationID: params?.row?.notificationID,
                        isNew: params?.row?.isNew,
                        assigneeName: params?.row?.assigneeName
                    },
                    from: "CURFQAssignedToMe"
                };
                return (
                    <Link
                        to={
                            status !== "Internal RFQ Not Created"
                                ? "/layout/AllMmrfq"
                                : "#"
                        }
                        target="_blank"
                        style={{ textDecoration: "none" }}
                        state={{ payload }}
                        onClick={() => {
                            if (status !== "Internal RFQ Not Created") {
                                localStorage.setItem(
                                    "AllMmrfq",
                                    JSON.stringify(payload)
                                );
                            }
                        }}
                    >
                        <AssMmrfqID value={params?.value} />
                    </Link>
                );
            }
        },

        {
            field: "companyName",
            headerName: "Company Name",
            minWidth: 250,
            disableColumnMenu: true,
            renderCell: (params) => {
                const name = params.value || "";
                const truncatedName = name;
                const logoUrl = params.row.companyLogo
                    ? generateCompanyLogo(
                          params.row.companyRecId,
                          params.row.companyLogo
                      )
                    : defaultlogo;
                const payload = {
                    companyRecId: params.row?.companyRecId,
                    compDetails: params.row,
                    from: getFromValue()
                };
                return (
                    <Link
                        to="/layout/CompanyProfilePage"
                        target="_blank"
                        state={{ payload }}
                        onClick={() => {
                            localStorage.setItem(
                                "CompanyProfilePage",
                                JSON.stringify(payload)
                            );
                        }}
                        style={{ textDecoration: "none" }}
                    >
                        <Box
                            sx={{
                                display: "flex",
                                alignItems: "center",
                                gap: 1,
                                // overflow: "hidden",
                                // textOverflow: "ellipsis",
                                // whiteSpace: "nowrap",
                                height: "100%",
                                cursor: "pointer"
                            }}
                        >
                            {logoUrl && (
                                <img
                                    src={logoUrl}
                                    alt={name}
                                    width={28}
                                    height={28}
                                    style={{
                                        borderRadius: "50%",
                                        border: "1px solid #D8D8D8"
                                    }}
                                />
                            )}
                            <Typography variant="body2" className="hoverClr">
                                {truncatedName}
                            </Typography>
                        </Box>
                    </Link>
                );
            }
        },

        // {
        //   field: "certifications",
        //   headerName: "Mandatory Certifications",
        //   width: 200,
        //   disableColumnMenu: true,

        //   renderCell: (params) => (
        //     <CertTypeCell
        //       value={params.value}
        //       isIndustryType={false}
        //       onChipClick={() => handleOpenDrawer(params.row)}
        //     />
        //   ),
        // },
        {
            field: "rfq_end_date",
            headerName: "CORFQ End Date",
            width: 200,
            disableColumnMenu: true
        },

        {
            field: "partner_response",
            headerName: "Partner Quotes",
            width: 180,
            disableColumnMenu: true,
            renderCell: (params) => {
                return (
                    <Chip
                        size="small"
                        label={
                            params?.value !== "Yet to Start"
                                ? `${params?.value} Quotes Received`
                                : `${params?.value}`
                        }
                        color={
                            params?.value === "Yet to Start"
                                ? "info"
                                : "default"
                        }
                        variant={
                            params?.value === "Yet to Start"
                                ? "outlined"
                                : "filled"
                        }
                    />
                );
            }
        },

        // {
        //   field: "list_of_parts",
        //   headerName: "List of parts",
        //   width: 200,
        //   disableColumnMenu: true,
        //   renderCell: (params) => <PartTypeCell value={params?.value} />,
        // },

        {
            field: "total_order_value",
            headerName: "Total Order Value",
            width: 150,
            disableColumnMenu: true,
            renderCell: (params) => {
                const value = params.value;
                const currency = params?.row?.preferred_currency;
                const formattedValue = formatCurrencyValue(value, currency);
                return (
                    <>
                        <div style={{ display: "block" }}>
                            <Typography
                                variant="body2"
                                display="flex"
                                alignItems="center"
                            >
                                {getCurrencyIcon(
                                    params?.row?.preferred_currency
                                )}
                                <span style={{ paddingLeft: "5px" }}>
                                    {formattedValue}
                                </span>
                                <Tooltip title={params?.row?.priceType}>
                                    <IconButton>
                                        <InfoOutlinedIcon
                                            style={{ fontSize: "16px" }}
                                        />
                                    </IconButton>
                                </Tooltip>
                            </Typography>
                            <Typography
                                variant="caption"
                                color="text.secondary"
                                display="block"
                            >
                                {params?.row?.preferred_currency}
                            </Typography>
                        </div>
                    </>
                );
            }
        },

        {
            field: "key_account_manger_name",
            headerName: "Key Account Manager",
            width: 250,
            disableColumnMenu: true,
            renderCell: (params) => {
                const name = params.value || "";
                return (
                    <Grid
                        container
                        spacing={2}
                        alignItems="center"
                        width="100%"
                    >
                        <Grid size={{ xs: 2, md: 2 }}>
                            <img
                                src={
                                    generatProfilePicUrl(
                                        params.row.key_account_manger_Id,
                                        params.row.key_account_manger_Id_logo,
                                        "Profile_Picture"
                                    ) || ""
                                }
                                alt="KAM"
                                width={28}
                                height={28}
                                style={{
                                    marginRight: "5px",
                                    borderRadius: "50%"
                                }}
                            />
                        </Grid>
                        <Grid size={{ xs: 10, md: 10 }}>
                            <Typography variant="body2" className="">
                                {name}
                            </Typography>
                        </Grid>
                    </Grid>
                );
            }
        },

        // {
        //   field: "added_on",
        //   headerName: "Added On",
        //   width: 150,
        //   disableColumnMenu: true,
        //   // renderCell: (params) => formatDate(params?.value),
        // },

        {
            field: "last_updated_on",
            headerName: "Last Updated On",
            width: 150,
            disableColumnMenu: true,
            sortComparator: (v1, v2) =>
                parseCustomDate(v1).getTime() - parseCustomDate(v2).getTime()
        },
        {
            field: "type_of_order",
            headerName: "Type of order",
            width: 150,
            disableColumnMenu: true,
            renderCell: (params) => {
                if (!params?.value) {
                    return "-";
                }
                return (
                    <Chip
                        variant="outlined"
                        label={params?.value}
                        size="small"
                        color={
                            params?.value === "Recurring Order"
                                ? "info"
                                : "warning"
                        }
                    />
                );
            }
        },
        ...(sourcingManagerHead() ||
        productionManagerHead() ||
        NPDManagerHead() ||
        isManagement()
            ? [
                  {
                      field: "assigneeName",
                      headerName: "Team Member",
                      width: 150,
                      disableColumnMenu: true,
                      cellClassName: () => "first-pinned-right",
                      headerClassName: "first-pinned-right",
                      renderCell: (params) => {
                          return (
                              <Grid
                                  container
                                  spacing={2}
                                  alignItems="center"
                                  width="100%"
                              >
                                  <Grid size={{ xs: 3, md: 3 }}>
                                      <Avatar
                                          src={
                                              generatProfilePicUrl(
                                                  params?.row?.assigneeID,
                                                  params?.row
                                                      ?.assigneeProfilePath,
                                                  "Profile_Picture"
                                              ) || ""
                                          }
                                          sx={{
                                              width: 28,
                                              height: 28,
                                              marginRight: 1
                                          }}
                                      />
                                  </Grid>
                                  <Grid size={{ xs: 9, md: 9 }}>
                                      <Typography variant="body2" className="">
                                          {params.value}
                                      </Typography>
                                  </Grid>
                              </Grid>
                          );
                      }
                  }
              ]
            : []),

        {
            field: "status",
            headerName: "MMRFQ Status",
            width: 150,
            disableColumnMenu: true,
            renderCell: (params) => {
                return (
                    <Tooltip title={params?.row?.status}>
                        <Chip
                            label={params.row.status}
                            variant="outlined"
                            size="small"
                            color={
                                params?.row?.status === "Internal RFQ Created"
                                    ? "info"
                                    : params?.row?.status === "Completed" ||
                                        params?.row?.status ===
                                            "Partners Approved"
                                      ? "success"
                                      : params?.row?.status ===
                                          "Quotes Received"
                                        ? "secondary"
                                        : "default"
                            }
                            sx={{
                                ...(params?.row?.status ===
                                    "Partially Approved" && {
                                    borderColor: "#F9A825",
                                    color: "#F9A825"
                                }),
                                ...(params?.row?.status === "Pending" && {
                                    border: "1px solid #ccc",
                                    color: " #797979"
                                })
                            }}
                        />
                    </Tooltip>
                );
            }
        },

        {
            field: "action",
            headerName: "Action",
            width: 70,
            disableColumnMenu: true,
            sortable: false,
            ...(!sourcingManagerHead() && {
                cellClassName: () => "first-pinned-right",
                headerClassName: "first-pinned-right"
            }),
            renderCell: (params) => <ActionMenu row={params.row} />
        }
    ];

    const ActionMenu = ({ row }) => {
        const visible =
            getLoggedInName() === row?.assigneeName &&
            row?.status === "Internal RFQ Not Created";
        const [anchorEl, setAnchorEl] = useState(null);
        const open = Boolean(anchorEl);

        const handleClick = async (event: { currentTarget: any }) => {
            setAnchorEl(event.currentTarget);
        };

        const handleCallMMRFQApi = async () => {
            dispath(setMmRfqFormData([]));
            try {
                const response = await getAutoPopulateCoRFQDetailsForMMRFQApi({
                    coRFQId: row?.curfq_id,
                    mmRFQId: null,
                    partId: null
                });

                if (response?.status === true) {
                    response.data[0]?.Part_Details?.forEach(
                        (item) => (item.selectedVendors = [])
                    );
                    response.data[0]["TechnicalDetails"] = {
                        Upload_Technical_File: "",
                        compliance: "",
                        quality_standard: "",
                        comments: ""
                    };
                    response.data[0]["expiryDate"] = "";
                    response.data[0]["isNextButtomClicked"] = false;

                    dispath(setMmRfqFormData(response?.data));
                } else {
                    console.log("Something went wrong");
                }
            } catch (err) {
                console.log("API Error:", JSON.stringify(err));
            } finally {
                setIsButtonDisable(false); // Reset in case you stay on page
            }
        };

        const handleClose = () => {
            setAnchorEl(null);
        };
        const handleCreateRfq = async () => {
            navigate("/layout/MMRFQForm");

            setIsButtonDisable(true); // Disable *immediately*
            await handleCallMMRFQApi();
        };
        // const today = new Date();

        // const day = String(today.getDate()).padStart(2, "0");
        // const monthNames = [
        //   "Jan",
        //   "Feb",
        //   "Mar",
        //   "Apr",
        //   "May",
        //   "Jun",
        //   "Jul",
        //   "Aug",
        //   "Sep",
        //   "Oct",
        //   "Nov",
        //   "Dec",
        // ];
        // const month = monthNames[today.getMonth()]; // Get abbreviated month name
        // const year = today.getFullYear(); // Get full year

        // const formattedDate = `${day}-${month}-${year}`;
        // // console.log(
        // //   "today date",
        // //   formattedDate,
        // //   " rfq_end_date",
        // //   row?.rfq_end_date
        // // );

        // const parseDate = (dateStr) => {
        //   if (!dateStr) return null;
        //   const [day, monthStr, year] = dateStr.split("-");
        //   const monthIndex = monthNames.indexOf(monthStr);
        //   return new Date(year, monthIndex, parseInt(day));
        // };

        // const isCorfqExpires =
        //   parseDate(row?.rfq_end_date) > parseDate(formattedDate);

        return (
            <>
                <IconButton onClick={handleClick}>
                    <MoreVertIcon />
                </IconButton>
                <Menu anchorEl={anchorEl} open={open} onClose={handleClose}>
                    {row?.status === "Internal RFQ Not Created" ? (
                        <MenuItem
                            sx={{ fontSize: "0.875rem" }}
                            onClick={handleCreateRfq}
                            disabled={isButtonDisable || !visible}
                        >
                            Create MM RFQ
                        </MenuItem>
                    ) : (
                        <MenuItem sx={{ fontSize: "0.875rem" }}>
                            <Link
                                to="/layout/AllMmrfq"
                                target="_blank"
                                style={{ textDecoration: "none" }}
                                state={{
                                    rfqData: {
                                        ID: row?.curfq_id,
                                        rfqID: row?.curfq_no,
                                        notificationID: row?.notificationID,
                                        isNew: row?.isNew,
                                        assigneeName: row?.assigneeName
                                    },
                                    from: "CURFQAssignedToMe"
                                }}
                                onClick={() => {
                                    localStorage.setItem(
                                        "AllMmrfq",
                                        JSON.stringify({
                                            rfqData: {
                                                ID: row?.curfq_id,
                                                rfqID: row?.curfq_no,
                                                notificationID:
                                                    row?.notificationID,
                                                isNew: row?.isNew,
                                                assigneeName: row?.assigneeName
                                            },
                                            from: "CURFQAssignedToMe"
                                        })
                                    );
                                }}
                            >
                                View MMRFQ
                            </Link>
                        </MenuItem>
                    )}
                </Menu>
            </>
        );
    };

    const formatDate = (dateStr: string): string => {
        if (!dateStr) return "-";
        const parts = dateStr?.split(" ")[0].split("-");
        const day = parts[0];
        const monthMap: { [key: string]: string } = {
            Jan: "01",
            Feb: "02",
            Mar: "03",
            Apr: "04",
            May: "05",
            Jun: "06",
            Jul: "07",
            Aug: "08",
            Sep: "09",
            Oct: "10",
            Nov: "11",
            Dec: "12"
        };
        const month = monthMap[parts[1]] || "00";
        const year = parts[2];
        return `${day}-${month}-${year}`;
    };

    const finalColumns = columns;

    /**Filter functionality start from here */
    function extractOptions(apiResponse: any[], keyName: string) {
        const section = apiResponse.find((item) => item[keyName]);
        if (!section) return [];

        // Handle keyAccountManager separately as it is a direct array
        if (Array.isArray(section[keyName])) {
            return section[keyName].map((name) => ({
                key: name,
                title: name
            }));
        }

        // Handle objects with choices
        if (section[keyName]?.choices) {
            return section[keyName].choices.map(
                (item: { key: any; link_name: any; value: any }) => ({
                    key: item.key || item.link_name || "unknown_key",
                    title: item.value || item.link_name || "Unknown"
                })
            );
        }

        return [];
    }

    const fetchFilterData = async () => {
        setIsFilterLoading(true);
        try {
            const filterData = await getCompanyRfqMetaFilterData();
            const filterDataStatus =
                await getCURFQAssignedToMeFilterMetaFieldsApi();

            let apiResponseCompany = [];
            let apiResponseStatus = [];

            if (filterData?.status) {
                apiResponseCompany = filterData?.data;
            }
            if (filterDataStatus?.status) {
                apiResponseStatus = filterDataStatus?.data;
            }
            type CompanyType = {
                company: string[];
            };
            const companyDetails: string[] = Array.from(
                new Set(rows?.map((item: any) => item?.companyName) ?? [])
            );
            const company: CompanyType[] = [{ company: companyDetails }];

            const apiResponse = filterDataStatus?.data;

            let teamMemberOptions = [];

            // const industryOptions = extractOptions(apiResponse, "industry_type");
            const statusOptions = extractOptions(apiResponse, "status");
            const keyAccountManagerOptions = extractOptions(
                apiResponse,
                "key_account_managers"
            );

            const department = getLoggedInUserDepartment();

            // Check if Department is Sourcing
            if (department === Department[0]) {
                teamMemberOptions = extractOptions(
                    apiResponse,
                    "sourcing_managers"
                );
            } else if (department === Department[1]) {
                // Check if Department is Production
                teamMemberOptions = extractOptions(
                    apiResponseStatus,
                    "production_managers"
                );
            } else if (department === Department[2]) {
                // Check if Department is NPD
                teamMemberOptions = extractOptions(
                    apiResponseStatus,
                    "npd_managers"
                );
            } else {
                if (tabValue === Department[0]) {
                    teamMemberOptions = extractOptions(
                        apiResponse,
                        "sourcing_managers"
                    );
                } else if (tabValue === Department[1]) {
                    teamMemberOptions = extractOptions(
                        apiResponse,
                        "production_managers"
                    );
                } else if (tabValue === Department[2]) {
                    teamMemberOptions = extractOptions(
                        apiResponse,
                        "npd_managers"
                    );
                }
            }

            const companyOptions = extractOptions(company, "company");

            const obj = {
                // industryOptions,
                statusOptions,
                keyAccountManagerOptions,
                teamMemberOptions,
                companyOptions
            };
            setFilterOptions(obj);
        } catch (error) {
            console.error("Error fetching filter data:", error);
        } finally {
            setIsFilterLoading(false);
        }
    };

    const filterData = (
        rows: any[],
        filters: {
            status: any;
            keyAccountManager: any;
            sourcingManager: any;
            company: any;
        }
    ) => {
        return rows?.filter(
            (row: {
                status: string;
                assigneeName: string;
                key_account_manger_name: string;
                companyName: any;
            }) => {
                const statusArray =
                    row?.status?.toLowerCase()?.split(/\s*,\s*/) || [];
                const keyAccountManagerArray =
                    row?.key_account_manger_name
                        ?.toLowerCase()
                        ?.split(/\s*,\s*/) || [];
                const sourcingManagerArray =
                    row?.assigneeName?.toLowerCase()?.split(/\s*,\s*/) || [];
                const companyArray =
                    row?.companyName?.toLowerCase().split(/\s*,\s*/) || [];
                // Get filter values, ignore empty ones
                const {
                    status = [],
                    keyAccountManager = [],
                    sourcingManager = [],
                    company = []
                } = filters;

                const statusMatch =
                    status?.length === 0 ||
                    status?.some((sol: string) =>
                        statusArray?.includes(sol.toLowerCase())
                    );

                const keyAccounManagerMatch =
                    keyAccountManager?.length === 0 ||
                    keyAccountManager?.some((loc: string) =>
                        keyAccountManagerArray.includes(loc.toLowerCase())
                    );
                const sourcingManagerMatch =
                    sourcingManager?.length === 0 ||
                    sourcingManager?.some((loc: string) =>
                        sourcingManagerArray.includes(loc.toLowerCase())
                    );
                const companyMatch =
                    company?.length === 0 ||
                    company?.some((cert: string) =>
                        companyArray?.includes(cert.toLowerCase())
                    );

                // **Must match ALL applied filters**
                return (
                    sourcingManagerMatch &&
                    statusMatch &&
                    keyAccounManagerMatch &&
                    companyMatch
                );
            }
        );
    };

    const handleApply = async () => {
        setIsApplyFilter(true);
        let filters = {
            status:
                selectedStatus?.map((item) => item?.title.toLowerCase()) || [],
            keyAccountManager:
                selectedKeyAccountManager?.map((item) =>
                    item?.title.toLowerCase()
                ) || [],
            sourcingManager:
                selectedSourcingManager?.map((item) =>
                    item?.title?.toLowerCase()
                ) || [],
            company:
                selectedCompany?.map((item) => item?.title.toLowerCase()) || []
        };
        const filteredResults = filterData(rows, filters);
        setFilteredRows(filteredResults);
        setAnchorEl(null);
        setFilteredSelectedStatus(selectedStatus);
        setFilteredSelectedKeyAccountManager(selectedKeyAccountManager);
        setFilteredSelectedSourcingManager(selectedSourcingManager);
        setFilteredSelectedCompany(selectedCompany);

        if (
            selectedStatus?.length == 0 &&
            selectedKeyAccountManager?.length == 0 &&
            selectedSourcingManager?.length === 0 &&
            selectedCompany?.length === 0
        ) {
            setFilteredRows(rows);
            setFilteredSelectedStatus(selectedStatus);
            setFilteredSelectedKeyAccountManager(selectedKeyAccountManager);
            setFilteredSelectedSourcingManager(selectedSourcingManager);
            setFilteredSelectedCompany(selectedCompany);
        }
    };

    const handleRemoveFilter = (category: string, item: { title: any }) => {
        if (removeFilter == true) {
            setRemoveFilter(false);
        } else {
            setRemoveFilter(true);
        }
        switch (category) {
            case "status":
                setSelectedStatus((prev) =>
                    prev.filter((i) => i.title !== item.title)
                );
                break;
            case "keyAccountManager":
                setSelectedKeyAccountManager((prev) =>
                    prev.filter((i) => i.title !== item.title)
                );
                break;
            case "sourcingManager":
                setSelectedSourcingManager((prev) =>
                    prev.filter((i) => i.title !== item.title)
                );
                break;
            case "company":
                setSelectedCompany((prev) =>
                    prev.filter((i) => i.title !== item.title)
                );
                break;
            default:
                break;
        }
    };

    // Run `handleApply` after any filter changes
    useEffect(() => {
        handleApply();
        if (
            selectedStatus?.length == 0 &&
            selectedKeyAccountManager?.length == 0 &&
            selectedSourcingManager?.length === 0 &&
            selectedCompany?.length === 0
        ) {
            setIsApplyFilter(false);
        }
    }, [removeFilter]);

    const assignedIndividualAccess =
        sourcingManager() ||
        sourcingManagerHead() ||
        NPDManagerHead() ||
        NPDManager() ||
        productionManagerHead() ||
        productionManager();

    return (
        <>
            <Breadcrumbs aria-label="breadcrumb" sx={{ marginBottom: "10px" }}>
                <Typography key="account" sx={{ fontSize: "14px" }}>
                    <Link
                        to="/layout/Dashboard"
                        style={{
                            color: "#0070BA",
                            fontSize: "14px",
                            textDecoration: "none"
                        }}
                    >
                        Home
                    </Link>
                </Typography>
                {[
                    <>
                        <Typography key="final" sx={{ fontSize: "14px" }}>
                            Assigned CORFQs
                        </Typography>
                    </>
                ]}
            </Breadcrumbs>

            {assignedIndividualAccess ? (
                <Typography variant="h5" mb={1}>
                    Assigned CORFQs
                </Typography>
            ) : (
                <>
                    <Typography variant="h5" mb={1}>
                        Assigned CORFQs
                    </Typography>
                    <Tabs
                        value={tabValue}
                        onChange={handleChange}
                        textColor="primary"
                        indicatorColor="primary"
                        aria-label="secondary tabs example"
                        sx={{
                            "& .MuiTab-root": {
                                textTransform: "none"
                            }
                        }}
                    >
                        <Tab value="Sourcing" label="Sourcing CORFQs" />
                        <Tab value="Production" label="Production CORFQs" />
                        <Tab value="NPD" label="NPD CORFQs" />
                    </Tabs>
                </>
            )}
            <Box
                sx={{
                    borderRadius: "5px",
                    marginTop: "16px",
                    background: "#fff",
                    padding: "15px"
                }}
            >
                <Grid container spacing={2}>
                    <Grid size={{ xs: 12, md: 6 }}>
                        {rows?.length > 1 && (
                            <Grid container spacing={2}>
                                {/* Search Section */}
                                <Grid size={{ xs: 12, md: 7 }}>
                                    <TextField
                                        label="Search by CORFQ ID & CORFQ Name"
                                        size="small"
                                        variant="outlined"
                                        fullWidth
                                        inputRef={searchInputRef}
                                        value={searchTerm}
                                        onChange={handleSearch}
                                    />
                                </Grid>
                                {/* Filter section */}
                                <Grid
                                    size={{ xs: 12, md: 5 }}
                                    sx={{
                                        color: "grey",
                                        display: "flex",
                                        alignItems: "center"
                                    }}
                                >
                                    <Box>
                                        <IconButton onClick={handleClick}>
                                            <Badge
                                                badgeContent={
                                                    filteredSelectedSourcingManager?.length +
                                                    filteredSelectedStatus?.length +
                                                    filteredSelectedKeyAccountManager?.length +
                                                    filteredSelectedCompany?.length
                                                }
                                                color="primary"
                                            >
                                                <FilterAltOutlinedIcon />
                                            </Badge>
                                        </IconButton>

                                        <Popper
                                            open={Boolean(anchorEl)}
                                            anchorEl={anchorEl}
                                            placement="bottom-start"
                                            sx={{ zIndex: 13 }}
                                        >
                                            <Paper
                                                ref={popperRef}
                                                sx={{
                                                    p: 2,
                                                    width: 350,
                                                    boxShadow: 3,
                                                    borderRadius: 2
                                                }}
                                            >
                                                <Box
                                                    sx={{
                                                        fontWeight: "bold",
                                                        mb: 2,
                                                        display: "flex",
                                                        justifyContent:
                                                            "space-between"
                                                    }}
                                                >
                                                    Filter{" "}
                                                    <Button
                                                        size="small"
                                                        variant="outlined"
                                                        onClick={handleClearAll}
                                                    >
                                                        CLEAR ALL
                                                    </Button>
                                                </Box>
                                                {!isFilterLoading ? (
                                                    <Box sx={{ mb: 2 }}>
                                                        {(sourcingManagerHead() ||
                                                            productionManagerHead() ||
                                                            NPDManagerHead() ||
                                                            Management()) && (
                                                            <Autocomplete
                                                                multiple
                                                                limitTags={2}
                                                                sx={{
                                                                    marginBottom:
                                                                        "15px"
                                                                }}
                                                                size="small"
                                                                id="multiple-limit-tags"
                                                                value={
                                                                    selectedSourcingManager
                                                                }
                                                                onChange={(
                                                                    event,
                                                                    newValue
                                                                ) =>
                                                                    setSelectedSourcingManager(
                                                                        newValue ||
                                                                            []
                                                                    )
                                                                }
                                                                options={[
                                                                    ...(filterOptions?.teamMemberOptions ||
                                                                        [])
                                                                ]?.sort(
                                                                    (a, b) =>
                                                                        a?.title?.localeCompare(
                                                                            b?.title
                                                                        )
                                                                )}
                                                                getOptionLabel={(
                                                                    option
                                                                ) =>
                                                                    option?.title ||
                                                                    ""
                                                                }
                                                                renderOption={(
                                                                    props,
                                                                    option
                                                                ) => (
                                                                    <li
                                                                        {...props}
                                                                        style={{
                                                                            display:
                                                                                "flex",
                                                                            alignItems:
                                                                                "center",
                                                                            gap: 10
                                                                        }}
                                                                    >
                                                                        <Typography>
                                                                            {
                                                                                option.title
                                                                            }
                                                                        </Typography>
                                                                    </li>
                                                                )}
                                                                renderInput={(
                                                                    params
                                                                ) => (
                                                                    <TextField
                                                                        {...params}
                                                                        label="Team Member"
                                                                        placeholder="Select Team Member"
                                                                    />
                                                                )}
                                                            />
                                                        )}

                                                        <Autocomplete
                                                            multiple
                                                            size="small"
                                                            sx={{
                                                                marginBottom:
                                                                    "15px"
                                                            }}
                                                            limitTags={2}
                                                            id="multiple-limit-tags"
                                                            options={[
                                                                ...(filterOptions?.keyAccountManagerOptions ||
                                                                    [])
                                                            ]?.sort((a, b) =>
                                                                a?.title?.localeCompare(
                                                                    b?.title
                                                                )
                                                            )}
                                                            getOptionLabel={(
                                                                option
                                                            ) =>
                                                                option?.title ||
                                                                ""
                                                            }
                                                            value={
                                                                selectedKeyAccountManager
                                                            }
                                                            onChange={(
                                                                event,
                                                                newValue
                                                            ) =>
                                                                setSelectedKeyAccountManager(
                                                                    newValue ||
                                                                        []
                                                                )
                                                            }
                                                            isOptionEqualToValue={(
                                                                option,
                                                                value
                                                            ) =>
                                                                option.title ===
                                                                value?.title
                                                            }
                                                            renderInput={(
                                                                params
                                                            ) => (
                                                                <TextField
                                                                    {...params}
                                                                    label="Key Account Manager"
                                                                    placeholder="Select Key Account Manager"
                                                                />
                                                            )}
                                                        />
                                                        <Autocomplete
                                                            multiple
                                                            size="small"
                                                            sx={{
                                                                marginBottom:
                                                                    "15px"
                                                            }}
                                                            limitTags={2}
                                                            id="multiple-limit-tags"
                                                            options={(
                                                                filterOptions?.statusOptions ||
                                                                []
                                                            )
                                                                .filter(
                                                                    (opt) =>
                                                                        opt?.title?.toLowerCase() !==
                                                                        "not applicable"
                                                                )
                                                                .sort((a, b) =>
                                                                    a?.title?.localeCompare(
                                                                        b?.title
                                                                    )
                                                                )}
                                                            getOptionLabel={(
                                                                option
                                                            ) =>
                                                                option?.title ||
                                                                ""
                                                            }
                                                            value={
                                                                selectedStatus
                                                            }
                                                            onChange={(
                                                                event,
                                                                newValue
                                                            ) =>
                                                                setSelectedStatus(
                                                                    newValue ||
                                                                        []
                                                                )
                                                            }
                                                            isOptionEqualToValue={(
                                                                option,
                                                                value
                                                            ) =>
                                                                option.title ===
                                                                value?.title
                                                            }
                                                            renderInput={(
                                                                params
                                                            ) => (
                                                                <TextField
                                                                    {...params}
                                                                    label="MMRFQ Status"
                                                                    placeholder="Select MMRFQ Status"
                                                                />
                                                            )}
                                                        />
                                                        <Autocomplete
                                                            multiple
                                                            size="small"
                                                            sx={{
                                                                marginBottom:
                                                                    "15px"
                                                            }}
                                                            limitTags={2}
                                                            id="multiple-limit-tags"
                                                            options={[
                                                                ...(filterOptions?.companyOptions ||
                                                                    [])
                                                            ]?.sort((a, b) =>
                                                                a?.title?.localeCompare(
                                                                    b?.title
                                                                )
                                                            )}
                                                            value={
                                                                selectedCompany
                                                            }
                                                            onChange={(
                                                                event,
                                                                newValue
                                                            ) =>
                                                                setSelectedCompany(
                                                                    newValue ||
                                                                        []
                                                                )
                                                            }
                                                            getOptionLabel={(
                                                                option
                                                            ) =>
                                                                option?.title ||
                                                                ""
                                                            }
                                                            isOptionEqualToValue={(
                                                                option,
                                                                value
                                                            ) =>
                                                                option.title ===
                                                                value?.title
                                                            }
                                                            //  disabled={(selectedIndustry || []).length == 0}
                                                            renderInput={(
                                                                params
                                                            ) => (
                                                                <TextField
                                                                    {...params}
                                                                    label="Company"
                                                                    placeholder="Select Company"
                                                                />
                                                            )}
                                                        />
                                                    </Box>
                                                ) : (
                                                    <Box
                                                        display="flex"
                                                        justifyContent="center"
                                                        alignItems="center"
                                                        height="50vh"
                                                    >
                                                        <ThreeDot
                                                            color="#1976d2"
                                                            size="medium"
                                                            text=""
                                                            textColor=""
                                                        />
                                                    </Box>
                                                )}
                                                {/* Apply / Cancel Buttons */}
                                                <Box
                                                    sx={{
                                                        display: "flex",
                                                        justifyContent:
                                                            "space-between",
                                                        mt: 2
                                                    }}
                                                >
                                                    <Button
                                                        onClick={handleClose}
                                                        color="error"
                                                    >
                                                        CANCEL
                                                    </Button>
                                                    <Button
                                                        variant="contained"
                                                        color="primary"
                                                        onClick={handleApply}
                                                    >
                                                        APPLY
                                                    </Button>
                                                </Box>
                                            </Paper>
                                        </Popper>
                                    </Box>
                                </Grid>
                            </Grid>
                        )}
                    </Grid>

                    <Grid size={{ xs: 12, md: 12 }}>
                        {/* Selected Filters as Chips */}
                        {isApplyFilter == true && (
                            <Box
                                sx={{
                                    display: "flex",
                                    flexWrap: "wrap",
                                    gap: 1,
                                    "& .MuiPopper-root": {
                                        zIndex: 100
                                    }
                                }}
                                mb={2}
                            >
                                {filteredSelectedStatus?.map((item, index) => (
                                    <Chip
                                        key={`status-${index}`}
                                        label={item.title}
                                        onDelete={() =>
                                            handleRemoveFilter("status", item)
                                        }
                                        size="small"
                                    />
                                ))}
                                {filteredSelectedKeyAccountManager?.map(
                                    (item, index) => (
                                        <Chip
                                            key={`keyAccountManager-${index}`}
                                            label={item.title}
                                            onDelete={() =>
                                                handleRemoveFilter(
                                                    "keyAccountManager",
                                                    item
                                                )
                                            }
                                            size="small"
                                        />
                                    )
                                )}
                                {filteredSelectedSourcingManager?.map(
                                    (item, index) => (
                                        <Chip
                                            key={`sourcingManager-${index}`}
                                            label={item.title}
                                            onDelete={() =>
                                                handleRemoveFilter(
                                                    "sourcingManager",
                                                    item
                                                )
                                            }
                                            size="small"
                                        />
                                    )
                                )}
                                {filteredSelectedCompany?.map((item, index) => (
                                    <Chip
                                        key={`company-${index}`}
                                        label={item?.title}
                                        onDelete={() =>
                                            handleRemoveFilter("company", item)
                                        }
                                        size="small"
                                    />
                                ))}
                                {/* Clear All Button - Show only when filters exist */}
                                {filteredSelectedKeyAccountManager?.length +
                                    filteredSelectedSourcingManager?.length +
                                    filteredSelectedStatus?.length >
                                    0 && (
                                    <Button
                                        size="small"
                                        variant="outlined"
                                        onClick={handleClearAllChip}
                                        sx={{
                                            fontSize: ".75rem !important",
                                            lineHeight: "1",
                                            borderRadius: "30px"
                                        }}
                                    >
                                        CLEAR ALL
                                    </Button>
                                )}
                            </Box>
                        )}
                    </Grid>
                </Grid>
                <Paper
                    sx={{
                        // height: 400,
                        // height:
                        //   filteredRows?.length > 4
                        //     ? "62vh"
                        //     : filteredRows?.length > 0
                        //       ? "auto"
                        //       : "62vh",
                        height: "62vh",
                        width: "100%",
                        display: "flex",
                        justifyContent: "center",
                        alignItems: "center"
                    }}
                >
                    {!isLoading ? (
                        filteredRows?.length > 0 ? (
                            <DataGridPro
                                pinnedColumns={pinnedColumns}
                                onPinnedColumnsChange={
                                    handlePinnedColumnsChange
                                }
                                getRowHeight={() => "auto"}
                                rows={filteredRows}
                                columns={finalColumns}
                                pagination={filteredRows?.length > 10}
                                paginationModel={paginationModel}
                                onPaginationModelChange={setPaginationModel}
                                pageSizeOptions={[10, 20]}
                                rowSelectionModel={selectedRows}
                                disableRowSelectionOnClick={true}
                                initialState={{
                                    sorting: {
                                        sortModel: [
                                            {
                                                field: "last_updated_on",
                                                sort: "desc"
                                            }
                                        ]
                                    }
                                }}
                                sx={{
                                    width: "100%",
                                    "& .MuiDataGrid-columnHeaderTitleContainer":
                                        {
                                            "& .MuiDataGrid-sortIcon": {
                                                opacity: "1 !important",
                                                visibility: "visible !important"
                                            }
                                        },
                                    "& .MuiDataGrid-cell": {
                                        display: "flex",
                                        alignItems: "center"
                                    },
                                    "& .MuiDataGrid-scrollbarFiller--pinnedRight":
                                        {
                                            backgroundColor: "#F4F4F4!important"
                                        }
                                }}
                            />
                        ) : (
                            <>
                                <div
                                    style={{
                                        display: "flex",
                                        flexDirection: "column",
                                        alignItems: "center",
                                        gap: "8px",
                                        padding: "20px"
                                    }}
                                >
                                    {(searchTerm && filteredRows.length == 0) ||
                                    (isApplyFilter &&
                                        filteredRows.length == 0) ? (
                                        "No Options available"
                                    ) : (
                                        <>
                                            <img
                                                src={emptyImage}
                                                alt="Empty"
                                                width={"300px"}
                                            />
                                            {sourcingManager() && (
                                                <b style={{ color: "#0009" }}>
                                                    CORFQs assigned to you will
                                                    appear here
                                                </b>
                                            )}
                                            {(isSourcingManagerHead() ||
                                                isManagement()) && (
                                                <b style={{ color: "#0009" }}>
                                                    All CORFQs assigned will
                                                    appear here
                                                </b>
                                            )}{" "}
                                        </>
                                    )}
                                </div>
                            </>
                        )
                    ) : (
                        <Box
                            display="flex"
                            justifyContent="center"
                            alignItems="center"
                            height="50vh"
                        >
                            <ThreeDot
                                color="#1976d2"
                                size="medium"
                                text=""
                                textColor=""
                            />
                        </Box>
                    )}
                </Paper>
                <CertificationDrawer
                    open={openDrawer}
                    onClose={handleCloseDrawer}
                    selectedPartner={selectedRow}
                />
            </Box>
        </>
    );
};
